/**
 * ProfessocialFacebookSettings stellt ist für die Bearbeitung der einzelnen Settings
 */

import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { FacebookSettingsConfiguration } from '@professocial/professocialTypes/types/configurationTypes'
import NoPageConnectedComponent from '@professocial/professocialFormComponents/FormComponents/NoPageConnectedComponent'
import { Grid, Paper, Theme } from '@mui/material'
import UserFacebookProfile from './subScreens/UserFacebookProfile'
import UserFacebookImpressum from './subScreens/UserFacebookImpressum'
import UserFacebookInfo from './subScreens/UserFacebookInfo'
import { getFacebookPageInitiated } from '../store/facebook/facebook.actions'
import { GetFacebookPageRequest } from '@3m5/sm_publish-frontend-api'
import { FacebookPage } from '@3m5/sm_publish-frontend-api'
import { getFacebookPage } from '../store/facebook/facebook.selector'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'
import { makeStyles } from '@mui/styles'

export interface Props {
  facebookSettingsConfiguration?: FacebookSettingsConfiguration
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
}))

const ProfessocialFacebookSettings: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { path } = useRouteMatch()

  const storedFacebookPageId: string | null = window.localStorage.getItem('facebookPageNetworkId')
  const facebookParams: GetFacebookPageRequest = {
    networkPageId: props.facebookSettingsConfiguration?.facebookPage?.networkPageId || storedFacebookPageId || '',
  }

  const dispatchGetFacebookPage = useCallback((params: GetFacebookPageRequest) => dispatch(getFacebookPageInitiated(params)), [dispatch])
  const facebookPage: FacebookPage | undefined = useSelector(getFacebookPage)

  useEffect(() => {
    dispatchGetFacebookPage(facebookParams)
  }, [],
  )

  return (
    <Grid container spacing={2} sx={{ px: 2, pb: 6 }}>
      <Grid
        xs={12}
        item
        container
        direction='row'
      >
        <Grid container item xs={12}>
          <Paper className={classes.paper} sx={{ py: storedFacebookPageId ? 5 : 2, px: storedFacebookPageId ? 5 : 4 }}>
            {storedFacebookPageId ? (
              <Switch>
                <Redirect exact from={`${path}`} to={`${path}/profileImage`} />
                <Route path={`${path}/profileImage`}>
                  <UserFacebookProfile config={facebookPage} facebookParams={facebookParams} />
                </Route>
                <Route path={`${path}/pageInfo`}>
                  <UserFacebookInfo config={facebookPage} updatePage={() => dispatchGetFacebookPage(facebookParams)} user={props.facebookSettingsConfiguration?.user} />
                </Route>
                <Route path={`${path}/imprint`}>
                  <UserFacebookImpressum config={facebookPage} />
                </Route>
              </Switch>
            ) : <NoPageConnectedComponent link='/user/settings/connect?startTab=facebook' />}
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}
export default ProfessocialFacebookSettings
